<template>
  <div class="mt-4">
    <v-row v-for="(item, name, index) in storageLocation" :key="index">
      <v-col sm="4" class="pa-0">
        <v-card height="100%" tile>
          <p class="pa-3 mb-0">
            {{russianNames[index]}}
          </p>
        </v-card>
      </v-col>
      <v-col sm="8" class="pa-0">
        <v-card height="100%" tile>
          <p class="pa-3 mb-0">
            {{item}}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "StorageComponent",
  data() {
    return {
      storageLocation: {
        address: '443011, г. Самара, ул. Академика Павлова, д. 1, к. 22',
        institution: 'Самарский национальный исследовательский университет имени академика С.П. Королева (Самарский университет)',
        subdivision: 'Межкафедральная учебно-научная лаборатория «Гербарий-SV»',
        room: 'Лаб. 612 м/м',
        genusIndex: this.genusIndex
      },
      russianNames: ['Адрес', 'Учреждение', 'Подразделение', 'Помещение', 'Индекс рода']
    }
  },
  props: {
    genusIndex: {
      required: true
    }
  },
}
</script>

<style scoped>

</style>